import * as tslib_1 from "tslib";
import * as io from 'socket.io-client';
import { Message, Event } from 'grey-message';
var DEFAULT_SOCKET_EVENT = 'default-kxl-im-socket-event';
var CONNECT = 'connect';
;
/** 回调项目 */
var CallbackItem = /** @class */ (function () {
    /** 构造函数 */
    function CallbackItem(callback) {
        /** 注册时间 */
        this.registrationTime = new Date().getTime();
        this.callback = callback;
    }
    Object.defineProperty(CallbackItem.prototype, "isTimeOut", {
        /** 是否超时 */
        get: function () {
            return new Date().getTime() - this.registrationTime >= 60 * 1000;
        },
        enumerable: true,
        configurable: true
    });
    return CallbackItem;
}());
export { CallbackItem };
/** 消息头 */
var Headers = /** @class */ (function () {
    function Headers() {
    }
    return Headers;
}());
export { Headers };
var SocketBasis = /** @class */ (function (_super) {
    tslib_1.__extends(SocketBasis, _super);
    function SocketBasis(url, token) {
        var _this = _super.call(this) || this;
        /** 回调 列表 */
        _this.callbackMap = new Map();
        /** 发送消息并接受回复 */
        _this.call = function (url, option) { return new Promise(function (resolve) {
            if (_this.socket) {
                _this.socket.emit(DEFAULT_SOCKET_EVENT, {
                    header: {
                        reqId: _this.generateReqId(resolve),
                        routerPath: url
                    },
                    body: option,
                });
            }
            else {
                console.error('发送失败 socket 不存在');
            }
        }); };
        /**
         * 链接
         * @returns 是否启动链接成功
         */
        _this.connect = function () {
            if (_this.socket) {
                return false;
            }
            var socket = io("//" + _this.url + "?token=" + _this.token + "&device=pc");
            socket.on(CONNECT, _this.onSocketConnectHandler(socket));
            socket.on(DEFAULT_SOCKET_EVENT, _this.onDefaultSocketEvent);
            return true;
        };
        /** 关闭 */
        _this.disConnect = function () {
            if (!_this.socket) {
                return;
            }
            _this.socket.close();
            _this.socket = undefined;
        };
        /** 创建 req Id (回调ID) */
        _this.generateReqId = function (resolve) {
            var reqId = (SocketBasis.reqIdRoot++).toString(16);
            _this.callbackMap.set(reqId, new CallbackItem(resolve));
            return reqId;
        };
        /** 链接成功 */
        _this.onSocketConnectHandler = function (socket) { return function () {
            _this.socket = socket;
            _this.send(new Connect());
        }; };
        /** 默认信道 */
        _this.onDefaultSocketEvent = function (e) {
            if (e.header.reqId) {
                var callbackItem = _this.callbackMap.get(e.header.reqId);
                _this.callbackMap.delete(e.header.reqId);
                if (callbackItem) {
                    callbackItem.callback({
                        header: e.header,
                        body: e.xlBaseResponse.ok ? e.xlBaseResponse.body : undefined,
                        err: e.xlBaseResponse.ok ? undefined : e,
                    });
                }
            }
            else {
                _this.send(new Information(e.header.routerPath, {
                    header: e.header,
                    body: e.xlBaseResponse.ok ? e.xlBaseResponse.body : undefined,
                    err: e.xlBaseResponse.ok ? undefined : e,
                }));
            }
        };
        _this.url = url;
        _this.token = token;
        return _this;
    }
    SocketBasis.reqIdRoot = new Date().getTime() - 1000000000000;
    return SocketBasis;
}(Message));
export default SocketBasis;
/** 链接成功事件 */
var Connect = /** @class */ (function (_super) {
    tslib_1.__extends(Connect, _super);
    function Connect() {
        return _super.call(this, Connect.TYPE) || this;
    }
    Connect.TYPE = Message.createType("Connect");
    return Connect;
}(Event));
export { Connect };
/** 接收到新消息事件 */
var Information = /** @class */ (function (_super) {
    tslib_1.__extends(Information, _super);
    function Information(type, req) {
        var _this = _super.call(this, type) || this;
        _this.req = req;
        return _this;
    }
    return Information;
}(Event));
export { Information };



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-socket/index.js
// module id = 4315
// module chunks = 0